import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/posthog";

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent("$pageview", { path: location.pathname });
  }, [location.pathname]);

  return null;
}
